var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-100" }, [
    _c("div", {
      directives: [
        {
          name: "t",
          rawName: "v-t",
          value: "biotech_bolt_valassz_atvetelt",
          expression: "'biotech_bolt_valassz_atvetelt'"
        }
      ],
      staticClass: "py-3 my-3"
    }),
    _vm._v(" "),
    _c("button", {
      staticClass: "custom-button unfilled",
      domProps: { textContent: _vm._s("Legközelebbi bolt") }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }